"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
exports.default = (function (size, color) { return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: size, height: size, viewBox: "0 0 24 24", fill: color },
    react_1.default.createElement("g", null,
        react_1.default.createElement("rect", { fill: "none", height: "24", width: "24" })),
    react_1.default.createElement("g", null,
        react_1.default.createElement("g", null,
            react_1.default.createElement("rect", { height: "7", width: "3", x: "4", y: "10" }),
            react_1.default.createElement("rect", { height: "7", width: "3", x: "10.5", y: "10" }),
            react_1.default.createElement("rect", { height: "3", width: "20", x: "2", y: "19" }),
            react_1.default.createElement("rect", { height: "7", width: "3", x: "17", y: "10" }),
            react_1.default.createElement("polygon", { points: "12,1 2,6 2,8 22,8 22,6" }))))); });
